var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.172,
    height: 33.605,
    viewBox: "0 0 34.172 33.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page-1",
    d: "M34.172,16.8a16.946,16.946,0,0,1-17.086,16.8A16.946,16.946,0,0,1,0,16.8,16.946,16.946,0,0,1,17.086,0,16.946,16.946,0,0,1,34.172,16.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(8.68 8.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.724,9.363A4.306,4.306,0,0,0,9.35,13.58,4.285,4.285,0,0,0,13.724,17.8,4.306,4.306,0,0,0,18.1,13.58,4.328,4.328,0,0,0,13.724,9.363Zm0,6.919a2.7,2.7,0,1,1,2.8-2.7A2.766,2.766,0,0,1,13.724,16.281Z",
    transform: "translate(-5.249 -5.442)",
    fill: "#ee5163"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 0.991,
    cy: 0.955,
    rx: 0.991,
    ry: 0.955,
    transform: "translate(12.029 2.867)",
    fill: "#ee5163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M21.932,7.8a4.965,4.965,0,0,0-3.588-1.351H11.3A4.6,4.6,0,0,0,6.35,11.223v6.754A4.652,4.652,0,0,0,7.785,21.5a5.1,5.1,0,0,0,3.554,1.284H18.31A5.155,5.155,0,0,0,21.9,21.5a4.628,4.628,0,0,0,1.4-3.492V11.223A4.634,4.634,0,0,0,21.932,7.8ZM21.8,18.011a3.16,3.16,0,0,1-.991,2.4,3.611,3.611,0,0,1-2.495.857H11.339a3.611,3.611,0,0,1-2.495-.857,3.245,3.245,0,0,1-.923-2.438V11.223a3.217,3.217,0,0,1,.923-2.4,3.552,3.552,0,0,1,2.495-.857h7.039a3.481,3.481,0,0,1,2.495.89,3.33,3.33,0,0,1,.923,2.372Z",
    transform: "translate(-6.35 -6.446)",
    fill: "#ee5163"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dda34cf6e32314f65ed2c7063ad40be0.svg";
export { ForwardRef as ReactComponent };